export default __webpack_public_path__ + "static/media/Logo-red.ecac9987.png";